"use client";
import styled from "../../../client-utils/styled/index.js";
import Box from "../../../components/atoms/Box/index.js";
import IconAtom from "../../../components/atoms/Icon/index.js";
import ListItemIcon from "../../../components/atoms/ListItemIcon/index.js";
import Typography from "../../../components/atoms/Typography/index.js";
import { SINGLE, TRIPLE } from "../../../constants/numbers.consts.js";
const coreComponentName = "SdbToggleListCheckmark";
export const Item = styled(Box, { name: coreComponentName, slot: "Item" })(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(TRIPLE),
    overflow: "hidden",
    width: "100%",
}));
export const Text = styled(Typography, { name: coreComponentName, slot: "Text" })({ flexGrow: SINGLE });
export const Icon = styled(IconAtom, { name: coreComponentName, slot: "Icon" })(({ theme }) => ({
    color: theme.vars.palette.surface.onVariant,
}));
export const StartIcon = styled(ListItemIcon, { name: coreComponentName, slot: "StartIcon" })({ minWidth: "24px" });
export const EndIcon = styled(ListItemIcon, { name: coreComponentName, slot: "EndIcon" })({ minWidth: "36px" });
